// Token service - provides auth token to non-React code (stores, etc.)
import { logError } from "@/lib/client/errors";

let getTokenFn: (() => Promise<string | null>) | null = null;

export const tokenService = {
  // Initialize with the getToken function from useAuth hook
  // This should be called once in a root component (e.g., searchContext or layout)
  initialize: (getToken: () => Promise<string | null>) => {
    getTokenFn = getToken;
  },

  // Get the current auth token
  // The store can call this directly without needing the hook
  getToken: async (): Promise<string | null> => {
    if (!getTokenFn) {
      logError(new Error("Token service not initialized. Call tokenService.initialize() first."));
      return null;
    }
    return getTokenFn();
  },

  // Check if initialized
  isInitialized: (): boolean => {
    return getTokenFn !== null;
  },
};
